"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.audio50 = void 0;
var util_1 = require("./util");
var audio50 = function (event) {
    return (0, util_1.audioEvent)(event, "audio-50");
};
exports.audio50 = audio50;
